const sliders = document.querySelectorAll('.slider');

for( i=0; i< sliders.length; i++ ) {
  
    sliders[i].classList.add('slider-swiper-container-' + i);

    var slider = new Swiper('.slider-swiper-container-' + i +' .slider-list' , {
        freeMode: true,
        watchOverflow: false,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 3,
        centeredSlides: true,
        onSlideChangeStart: function(){
            slidertext.slideTo(slider.activeIndex);
        },
        navigation: {
            nextEl: '.slider.slider-swiper-container-' + i + ' .swiper-button-next',
            prevEl: '.slider.slider-swiper-container-' + i + ' .swiper-button-prev',
        },
        breakpoints: {
            0: {
                spaceBetween: 16,
                
            },
            992: {
                spaceBetween: 110,
            }
            
        }
    });

    var slidertext = new Swiper('.slider-swiper-container-' + i +' .slider-list-text' , {
        freeMode: true,
        watchOverflow: false,
        preventClicks: true,
        preventClicksPropagation: true,
        slidesPerView: 3,
        centeredSlides: true,
        onSlideChangeStart: function(){
            slider.slideTo(slidertext.activeIndex);
        },
        breakpoints: {
            0: {
                spaceBetween: 16,
                
            },
            768: {
                spaceBetween: 16,
            },
            992: {
                spaceBetween: 16,
            },
            1200: {
                spaceBetween: 110,
            }
            
        }
    });
    
    slidertext.controller.control = slider;
    slider.controller.control = slidertext;

}